<template>
  <MoleculeAccessDenied/>
</template>

<script>
export default {
  name: 'OrganismAccessDenied',

  components: {
    MoleculeAccessDenied: () => import('@/components/molecules/MoleculeAccessDenied')
  }
}
</script>
